<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 477.559 512.003">
  <path
    d="M5.93 149.615 121 264.684c7.901 7.901 20.713 7.901 28.614 0s7.901-20.713 0-28.614l-44.568-44.565h316.313c31.036 0 56.198-25.16 56.198-56.2 0-31.04-25.16-56.2-56.198-56.2H105.046l44.568-44.57a20.172 20.172 0 0 0 5.927-14.31 20.15 20.15 0 0 0-5.927-14.3c-7.901-7.9-20.713-7.9-28.614 0L5.93 120.995c-7.9 7.9-7.9 20.72 0 28.62Z"
    fill="#5555ff"
  />
  <path
    d="M5.93 149.615 121 264.684c7.901 7.901 20.713 7.901 28.614 0s7.901-20.713 0-28.614l-44.568-44.565h139.247v-112.4H105.046l44.568-44.57a20.166 20.166 0 0 0 5.927-14.3c0-5.18-1.976-10.36-5.927-14.31-7.901-7.9-20.713-7.9-28.614 0L5.93 120.995c-7.9 7.9-7.9 20.72 0 28.62Z"
    fill="#8888ff"
  />
  <path
    d="M471.632 362.386 356.56 247.314c-7.901-7.901-20.713-7.901-28.614 0s-7.901 20.713 0 28.614l44.567 44.568H56.2v.001c-31.04 0-56.2 25.16-56.2 56.198 0 31.036 25.16 56.198 56.2 56.198h316.314l-44.568 44.568a20.17 20.17 0 0 0-5.927 14.308 20.17 20.17 0 0 0 5.927 14.308c7.901 7.901 20.713 7.901 28.614 0l115.072-115.072c7.902-7.906 7.902-20.718 0-28.619Z"
    fill="#444444"
    data-player="true"
  />
  <path
    d="M471.632 362.386 356.56 247.314c-7.901-7.901-20.713-7.901-28.614 0s-7.901 20.713 0 28.614l44.567 44.568H244.295v112.395h128.218l-44.568 44.568a20.17 20.17 0 0 0-5.927 14.308 20.17 20.17 0 0 0 5.927 14.308c7.901 7.901 20.713 7.901 28.614 0l115.072-115.072c7.903-7.904 7.903-20.716.001-28.617Z"
    fill="#808080"
    data-player="true"
  />
</svg>
